import React, { useState } from "react";

//Importar íconos de Material UI.
import { Search } from '@mui/icons-material/';

// OperatorToAsingSearcher: Componente que renderiza el buscador de operadores disponibles para ser asignados.

const OperatorToAsingSearcher = ({ operadores, setOperadorFiltered }) => {

    const [operadorSearch, setOperadorSearch] = useState(''); //Estado para actualizar el operador buscado.

    const onChangeSearch = (e) => { //Función pora filtrar al operador seleccionado.
        setOperadorSearch(e.target.value); //Actualizar el estado del operador buscado.
        if (e.target.value !== '') {
            //Filtrar de la lista de operadores, el operador buscado.
            let operador = operadores.filter((operador) => operador.Nombre.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase()))

            if (operador) { //Si existe alguna coincidencia con el operador buscado.
                console.log('existe un operador con ese nombre', operador);
                //Actualizar la lista de operadores con los que cumplan esa condición.
                setOperadorFiltered(operador);
            }
        }
        else { //Si el valor ingresado en el buscador es igual a vacío.
            console.log('no existe un operador con ese nombre');
            setOperadorFiltered(operadores); //Retornar la lista de sugerencias en vacía.
        }
    };

    return (
        <div className="search-with-text">

        {/*--------Buscador------------*/}
        <div className="input-with-icon">
            {/*                     <Search className="input-icon" /> */}
            <input
                placeholder="Buscar Operador..."
                className="search-input"
                onChange={onChangeSearch}
                value={operadorSearch}
            />
        </div>
    </div>
    )
};

export default OperatorToAsingSearcher;